export default __webpack_public_path__ + "static/media/succulent3.d4acc119.jpg";